export default __webpack_public_path__ + "static/media/satellite.b4ac37f0.png";